export default {
    // 목록 그대로 반환 (template에서 category/publishedDate 사용)
    getNoticeItems(state) {
        return state.noticeItems;
    },

    // id로 단건 찾기 (없으면 currentNotice 활용)
    getNoticeItem: (state) => (id) => {
        const numericId = Number(id);

        return (
            state.noticeItems.find((n) => n.id === numericId) ||
            state.currentNotice
        );
    },
};
